export default "__VITE_ASSET__85e4cea6__"